/* eslint-disable import/prefer-default-export */
export const CURSOR_HOME = 'Esc[2J';
